import PropTypes from "prop-types"
import React from "react"

import { Checkbox, FormControlLabel, Typography } from "@material-ui/core"
import clsx from "clsx"
import dayjs from "dayjs"
import Box from "~/components/Common/Box"
import useStyles from "./styles"

const DiscountDateTime = ({
  startDate,
  setStartDate,
  expirationDate,
  setExpirationDate,
  noExpiration,
  setNoExpiration,
  statusChanged,
  setStatusChanged,
}) => {
  const classes = useStyles()

  const handleStartDateChange = (e) => {
    setStartDate(e)
    //setExpirationDate(e)
    setStatusChanged(true)
  }

  const handleExpirationDateChange = (e) => {
    // if (startDate <= expirationDate) {
    setExpirationDate(e)
    setStatusChanged(true)
    // } else {
    //   console.error("error")
    // }
  }

  const handleExpiration = () => {
    setNoExpiration(!noExpiration)
    setStatusChanged(true)
  }

  return (
    <Box className="flex gap-1 items-center">
      <Box className="w-full md:w-1/3">
        <Typography color="secondary" className={classes.inputLabel}>
          Start Date
        </Typography>
        <input
          className="bg-[#F4F4F4] p-2 rounded-md w-full"
          type="date"
          id="dateInput"
          name="dateInput"
          value={dayjs(startDate).format("YYYY-MM-DD")}
          onChange={(e) => handleStartDateChange(e.target.value)}
        />
      </Box>
      {noExpiration ? null : (
        <Box className="w-full md:w-1/3">
          <Typography color="secondary" className={classes.inputLabel}>
            Expiration Date
          </Typography>
          <input
            className="bg-[#F4F4F4] p-2 rounded-md w-full"
            type="date"
            id="dateInput"
            name="dateInput"
            value={dayjs(expirationDate).format("YYYY-MM-DD")}
            min={dayjs().format("YYYY-MM-DD")}
            onChange={(e) => handleExpirationDateChange(e.target.value)}
          />
        </Box>
      )}
      <Box className={clsx("w-full md:w-1/3 md:mt-[32px]", classes.checkBox)}>
        <FormControlLabel
          style={{ margin: 0 }}
          control={
            <Checkbox
              color="secondary"
              checked={noExpiration}
              onChange={() => handleExpiration()}
            />
          }
          label={<Typography>Does not expire</Typography>}
          labelPlacement="end"
          color="secondary"
        />
      </Box>
    </Box>
  )
}

DiscountDateTime.propTypes = {
  startDate: PropTypes.any,
  setStartDate: PropTypes.func,
  expirationDate: PropTypes.any,
  setExpirationDate: PropTypes.func,
  noExpiration: PropTypes.bool,
  setNoExpiration: PropTypes.func,
  statusChanged: PropTypes.bool,
  setStatusChanged: PropTypes.func,
}

export default DiscountDateTime
